define('modules/base/modals/views/modal.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    'modules/base/views/model.view'
], function(
    Prospector,
    $,_,Backbone,
    BaseView
){
    var ModalView = BaseView.extend({
        className: 'modal-content',
        modelSelector: 'modal-body',
        initialize: function(options) {
            this.debugName = 'modal controller';
            if(options != undefined){
                if(options.parent != undefined){
                    this.parent = options.parent;
                }
            }
            BaseView.prototype.initialize.call(this, options);
            this.listenToOnce(Prospector, 'closingModal', this.beforeClose, this);
        },
        closeModal: function() {
            this.$(".close").click();
        },
        beforeClose:function(){
        },
        onRender: function() {
            if(this.filterSelector != ''){
                this.$(this.filterSelector).bind('keyup', $.proxy(this.querySearch, this));
            }
            this.$(this.mainBtnLoaderTextSelector).html(this.mainBtnLoaderRestingText);
        }
    });
    return ModalView;
});

